import React, { FC } from "react";
import { DrugFootnote } from "../../../../@types";
import { Footnote, Footnotes } from "../../../../components";

export const otherDrugFootnoteTestIdPrefix = "other-drug-information-footnote-";

export type OtherDrugInfoFoonoteType = {
  text: string;
  type: DrugFootnote;
};

export const OtherDrugInfoFootnotes: FC<{
  footnotes: OtherDrugInfoFoonoteType[];
}> = ({ footnotes }) =>
  footnotes.length ? (
    <Footnotes>
      {footnotes.map((footnote, index) => {
        return (
          <Footnote
            id={`footnote-${index}`}
            data-testid={`${otherDrugFootnoteTestIdPrefix}${index}`}
            className="ds-u-measure--wide ds-u-margin--0"
            text={
              <span className={`e2e-other-footnote-${footnote.type}`}>
                {footnote.text}
              </span>
            }
            marker={(index + 1).toString()}
            key={index}
          />
        );
      })}
    </Footnotes>
  ) : null;
